module.exports = new __parcel__URL__("email.very-specific-illu.43fa850c.png").toString();